import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
export var StyledDay = styled(Grid)({
  flexGrow: 0.5,
  minWidth: 80
});
export var StyledMonth = styled(Grid)({
  flexGrow: 0.5,
  minWidth: 80
});
export var StyledYear = styled(Grid)({
  flexGrow: 2,
  minWidth: 110
});
export var StyledSlash = styled(Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.default.light
  };
});